// Make sure headers names are lower case in this file
// As axios lower case all the headers before passing then in the response
export const CSRF_HEADER_NAME = 'x-csrf-token';
export const CSRF_LOCAL_STORAGE_KEY = 'csrfToken';
export const USER_ID_LOCAL_STORAGE_KEY = 'userId';
export const LOGGED_OUT_USER_ID_LOCAL_STORAGE_KEY = 'loggedOutUserId';
export const USER_ROLE_LOCAL_STORAGE_KEY = 'userRole';
export const USER_ID_SESSION_STORAGE_KEY = 'registrationUserId';
export const EMAIL_SESSION_STORAGE_KEY = 'registrationEmail';
export const PRESIGNUP_FLOW_SESSION_STORAGE_KEY = 'presignupEmailVerificationFlow';
export const PRESIGNUP_TOKEN_SESSION_STORAGE_KEY = 'presignupEmailVerificationToken';
export const EMAIL_LOCAL_STORAGE_KEY = 'email';
export const PHONE_LOCAL_STORAGE_KEY = 'phone';
export const FIRST_NAME_LOCAL_STORAGE_KEY = 'firstName';
export const LAST_NAME_LOCAL_STORAGE_KEY = 'lastName';
export const DOCUMENT_CLOSED_WHILE_CONNECTED = 'disconnectedWhileConnected';
export const FE_SESSION_ID_KEY = 'fe-session-id';
export const RISKIFIED_SESSION_ID_KEY = 'riskified-session-id';

export const SUB_USER_ID_LOCAL_STORAGE_KEY = 'subUserId';
export const SUB_USER_SCOPES_LOCAL_STORAGE_KEY = 'subUserScopes';

export const AI_CONTENT_FEEDBACK = 'ai-content-feedback';
export const PREFILL_DOB = 'signup-prefill-dob';
export const PREFILL_PHONE_NUMBER = 'signup-prefill-phone';
export const PREFILL_FIRST_NAME = 'signup-prefill-first-name';
export const PREFILL_LAST_NAME = 'signup-prefill-last-name';
export const OAUTH_PREFILL_FIRST_NAME = 'oauth-signup-prefill-first-name';
export const OAUTH_PREFILL_LAST_NAME = 'oauth-signup-prefill-last-name';
export const DEBIT_DEPOSIT_AMOUNT = 'debitDepositAmount';
export const DEBIT_DEPOSIT_FEE = 'debitDepositFee';
export const DEBIT_WITHDRAWAL_AMOUNT = 'debitWithdrawalAmount';
